import { createSelector } from '@reduxjs/toolkit'

// TODO: import Store type and add reducer type in Store interface
const getAuth = (state: any) => state.auth

export const authSelector = createSelector(getAuth, (auth) => auth)

export const generalDataSelector = createSelector(getAuth, (auth) => auth.generalData)
